import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Cookies from 'universal-cookie';

import IndustriesDisplay from './IndustriesDisplay';
import PackageSelection from './PackageSelection';
import OldPackageSelection from './OldPackageSelection';

import { checkProductCoupon, fixBanner } from '../../../../services/v2/productsService';
import { clearQueryParams } from '../../../../utils/helpers'
import { redirectToUrl } from '../../../../utils/navigation';

import {
  trackGenericPageInfo,
  trackHmcw,
  trackIndustrySelection
} from '../../../../services/v2/segmentAnalytics';

import './RPPProductPackage.css';

/**
 * RPPProductPackage.
 * Page for product.
 *
 * @author  Manny
 * @param   {Function}    props.changeIndustry    Handles industry change.
 * @param   {Object}      props.coupon            Coupon object.
 * @param   {Boolean}     props.industryCookie    Whether contains industry cookie.
 * @param   {Object}      props.method            Optional industry params.
 * @param   {Function}    props.onSelectPackage   Handles onClick for selecting a package.
 * @param   {Object}      props.product           Name of the product.
 * @param   {Number}      props.productId         Id number of the product.
 * @param   {Object}      props.productsConfig    Product configurations.
 * @param   {String}      props.selectedIndustry  Name of selected industry.
 * @param   {String}      props.selectedPackage   Name of selected package.
 * @returns {JSX.Element} The component markup.
 */

const RPPProductPackage = ({
  changeIndustry,
  coupon,
  industryCookie,
  method,
  onSelectPackage,
  product,
  productId,
  productsConfig,
  selectedIndustry,
  selectedPackage
}) => {
  const [show, setShow] = useState(false);
  const [packageKey, setPackageKey] = useState('cityscope');

  /* istanbul ignore next */
  useEffect(() => {
    const cookies = new Cookies();
    if (industryCookie) {
      cookies.set('industry', selectedIndustry);
    }
    if (productsConfig != null && selectedIndustry) {
      let newPackageKey = packageKey;
      if (packageKey === 'basic1UN') {
        newPackageKey = 'basic';
      }
      setPackageKey(newPackageKey);
    }
    if (product.industrySelected === false) {
      handleShow();
    } else {
      handleClose();
    }

    window.addEventListener('scroll', fixBanner);

    return () => {
      window.removeEventListener('scroll', fixBanner);
    };
  }, []);

  const isMobile = /Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent);

  let classNames = require('classnames');

  let containerClass = classNames({
    'col-sm-12': isMobile === false,
    'col-sm-12 no-padding': isMobile === true
  });

  let couponClass = classNames({
    'row no-margin page-dim padded-sides': selectedIndustry !== 'real_estate_agencies_and_valuers',
    'row no-margin page-dim padded-sides-sm coupon-align-packages':
      selectedIndustry === 'real_estate_agencies_and_valuers' && isMobile === false
  });

  /* istanbul ignore next */
  const handleClose = () => {
    setShow(false);
  };

  /* istanbul ignore next */
  const handleShow = () => {
    setShow(true);
  };

  /* istanbul ignore next */
  const showIndustryModal = () => {
    clearQueryParams();
    handleShow()
    trackGenericPageInfo('Change RPP Industry');
  };

  /* istanbul ignore next */
  const handleTrackIndustrySelection = (selectedIndustryKey) => {
    let oldIndustry =
      productsConfig.industries[
        selectedIndustry ? selectedIndustry : 'real_estate_agencies_and_valuers'
      ].title;
    let newIndustry = productsConfig.industries[selectedIndustryKey].title;
    trackIndustrySelection(oldIndustry, newIndustry);
  };

  /* istanbul ignore next */
  const handleChangeIndustry = (industryKey) => {
    const cookies = new Cookies();
    if (industryKey) {
      cookies.set('industry', industryKey);
    }

    let industry = productsConfig.industries[industryKey];

    handleTrackIndustrySelection(industryKey);

    let newPackageKey = Object.keys(industry.packages)[Object.keys(industry.packages).length - 1];
    if (newPackageKey === 'basic1UN') {
      newPackageKey = 'basic';
    }
    handleClose();
    setPackageKey(newPackageKey);
    window.history.pushState(industryKey, 'Core Store', '/product/rp-data-professional');
    changeIndustry(industryKey, newPackageKey);
  };

  /* istanbul ignore next */
  const redirectToHelpMeChoose = (link, pageName) => {
    trackHmcw(pageName, selectedIndustry);
    redirectToUrl(link);
  };

  /* istanbul ignore next */
  useEffect(() => {
    if (product.industrySelected === false && !window.location.href.includes('?industry=') && !selectedPackage) {
      clearQueryParams();
      handleShow();
    } else {
      handleClose();
    }
    setPackageKey(selectedPackage);
  }, [selectedPackage]);

  if (productsConfig != null) {
    let industryKey = selectedIndustry ? selectedIndustry : 'real_estate_agencies_and_valuers';

    return (
      <div>
        <div className='row no-margin'>
          <div className='col-sm-12'>
            <div className='row no-margin'>
              <div className='col-sm-12 section-title heading1 text-center margin-bottom-35' id='package_header'>
                RP Data
              </div>
            </div>

            <div className='row no-margin'>
              <div className={containerClass}>
                {coupon &&
                  Object.keys(coupon).length > 0 &&
                  checkProductCoupon(productId, coupon.productIds) &&
                  coupon.blueBoxText !== null && (
                    <div className={couponClass}>
                      <div className='col-sm-12 discount-alert blue-bg captions-semibold'>
                        <span>{coupon.blueBoxText}</span>
                      </div>
                    </div>
                  )}

                {isMobile &&
                  coupon &&
                  Object.keys(coupon).length > 0 &&
                  checkProductCoupon(productId, coupon.productIds) &&
                  coupon.blueBoxText !== null && <br />}
                {productsConfig !== null && industryKey === 'real_estate_agencies_and_valuers' && (
                  <PackageSelection
                    productPackages={productsConfig.industries[industryKey].packages}
                    method={method}
                    selectedIndustry={industryKey}
                    selectedPackage={selectedPackage}
                    onSelectPackage={onSelectPackage}
                  />
                )}
                {productsConfig !== null && industryKey !== 'real_estate_agencies_and_valuers' && (
                  <OldPackageSelection
                    productPackages={productsConfig.industries[industryKey].packages}
                    productsConfig={productsConfig}
                    selectedIndustry={industryKey}
                    selectedPackage={selectedPackage}
                    onSelectPackage={onSelectPackage}
                    method={method}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className='row spinner'>
        <i className='fa fa-spinner fa-pulse fa-3x fa-fw'></i>
        <span className='sr-only'>Loading...</span>
      </div>
    );
  }
};

RPPProductPackage.propTypes = {
  changeIndustry: PropTypes.func.isRequired,
  coupon: PropTypes.object,
  industryCookie: PropTypes.bool.isRequired,
  method: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  productId: PropTypes.number.isRequired,
  productsConfig: PropTypes.object,
  selectedIndustry: PropTypes.string.isRequired,
  selectedPackage: PropTypes.string.isRequired
};

export default RPPProductPackage;
